export default "__VITE_ASSET__ZBBX5AV5__"